// frontend/src/components/common/ContentCarousel.js (با Tailwind CSS نهایی و رفع خطای Destructuring)

import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react'; // ✅ اضافه کردن آیکون
import ContentCard from '../Product/ContentCard'; 

/**
 * کامپوننت کروسل برای نمایش افقی کارت‌های محتوا
 * [حذف توضیحات برای اختصار]
 */
const ContentCarousel = ({ title, data, showMoreLink = true, querySlug, onCardClick }) => {
    
    const finalShowMoreLink = querySlug 
        ? `/products/list/${querySlug}` 
        : '/categories';

    const customWidthForThreeItems = 'w-[calc((100%-2rem)/3.5)] sm:w-[calc((100%-2rem)/3.5)]'; 

    return (
        <section className="mt-1">
            
            {/* ----------------- ۱. هدر کروسل (بدون تغییر) ----------------- */}
            <div className="flex justify-between items-center mb-2 px-2 sm:px-0">
                <h2 className="text-[14px] md:text-[14px] font-medium text-gray-800 rtl mb-2">
                    {title}
                </h2>
                
                {showMoreLink && finalShowMoreLink && (
                    <Link 
                        to={finalShowMoreLink} 
                        className="text-[11px] font-medium text-gray-400 hover:text-gray-800 transition duration-150 rtl flex items-center gap-1"
                    >
                        <span>بیشتر</span>
                        <ChevronLeft size={14} /> {/* ✅ آیکون با اندازه مناسب */}
                    </Link>
                )}
            </div>
            
            {/* ----------------- ۲. کانتینر اصلی اسکرول افقی ----------------- */}
            <div 
                className="flex overflow-x-auto gap-4 pb-1 px-4 sm:px-0 scrollbar-hide" 
            >
                {Array.isArray(data) && data.length > 0 ? (
                    data
                        .filter(item => item && typeof item === 'object' && item.id)
                        .map((item) => (
                            <div 
                                key={item.id} 
                                className={`flex-shrink-0 ${customWidthForThreeItems}`} 
                                onClick={onCardClick ? () => onCardClick(item.slug) : undefined}
                            >
                                <ContentCard data={item} />
                            </div>
                        ))
                ) : (
                    <div className="text-center text-gray-500 py-6 text-[11px]">
                        محتوایی برای نمایش وجود ندارد
                    </div>
                )}
            </div>
            
            {/* ----------------- ۳. خط جداکننده نازک خاکستری زیر کروسل ----------------- */}
            <div className="mt-1 border-b border-gray-200 w-full"></div>
            
        </section>
    );
};

export default ContentCarousel;